import { render, staticRenderFns } from "./Heading2.vue?vue&type=template&id=57d985f8&"
import script from "./Heading2.vue?vue&type=script&lang=js&"
export * from "./Heading2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports